import React from 'react';

interface FridgeInterestButtonProps {
  productNames: string[];
  pressed: boolean;
  onToggle: () => void;
}

/** Shown only when a selected product has lead_priority. Does not create an order. */
export const FridgeInterestButton: React.FC<FridgeInterestButtonProps> = ({
  productNames,
  pressed,
  onToggle,
}) => {
  if (productNames.length === 0) return null;

  return (
    <div className="border border-fuchsia-200 rounded-xl p-4 bg-fuchsia-50 space-y-2">
      <button
        type="button"
        aria-pressed={pressed}
        onClick={onToggle}
        className={`w-full min-h-[48px] rounded-xl font-bold text-sm ${
          pressed
            ? 'bg-fuchsia-700 text-white'
            : 'bg-white text-fuchsia-800 border-2 border-fuchsia-300'
        }`}
      >
        {pressed ? 'Ernsthaftes Interesse gemerkt' : 'Ernsthaftes Interesse'}
      </button>
      <p className="text-xs text-fuchsia-900">
        {productNames.join(', ')} — Follow-up über High, fällig in 2 Tagen. Keine Bestellung.
      </p>
    </div>
  );
};
